import { render, staticRenderFns } from "./BaseWebpageLoading.vue?vue&type=template&id=5be03116&"
import script from "./BaseWebpageLoading.vue?vue&type=script&lang=js&"
export * from "./BaseWebpageLoading.vue?vue&type=script&lang=js&"
import style0 from "./BaseWebpageLoading.vue?vue&type=style&index=0&id=5be03116&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports